import { render } from "./SensorStatPressure.vue?vue&type=template&id=15644995"
import script from "./SensorStatPressure.vue?vue&type=script&lang=js"
export * from "./SensorStatPressure.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__